import { Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { EventService } from '../../service/event.service';
import { UserDataService } from '../../service/userDataService';

@Component({
    selector: 'app-header',
    templateUrl: 'header.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class HeaderComponent {
    isBetmgmLabel: boolean;
    showNewHeader: boolean;
    constructor(
        private userDataService: UserDataService,
        private eventService: EventService,
    ) {
        this.isBetmgmLabel = this.userDataService.userData.userInfo.labelInfo.brandId.toLowerCase().includes('mgm');
        this.showNewHeader = this.userDataService.userData?.configParams?.isBrazilBankRegEnabled;
    }

    closeCashier() {
        const appholder = document.getElementById('cashierAppHolder') as any;
        appholder.style.display = 'none';
        this.eventService.raiseCloseEvent(true);
    }
}
